import { CheckCircle } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { GetCompanyResponseDto } from '../../../services/dtos/GetCompanyResponseDto';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';

interface Props {
  company: GetCompanyResponseDto;
}

export const VerifiedCompanyIcon: FC<Props> = ({ company }) => {
  const { t } = useTranslation(['common']);
  if (company?.caCompany?.verified !== 'Verified') return null;

  return (
    <Tooltip title={t('common:verification:verified')} arrow>
      <CheckCircle htmlColor="#00d310" />
    </Tooltip>
  );
};
